import React, { useEffect } from 'react'
import WorkImage from '../../../assets/kiedImg.png'
import InternshipBg from '../../../assets/internship-bg.png'
import AimIcon from '../../../assets/aimIcon.png'
import MissionIcon from '../../../assets/rocketIcon.png'
import VisionIcon from '../../../assets/visionicon.png'
import InfoCard from '../../../components/common/InfoCard/InfoCard'
import Navigator from '../../../components/common/Navigator'
import { useAboutkied } from '../api'

const AboutKied = () => {
  const { data, isLoading, isError } = useAboutkied()
  useEffect(() => {
    if (!data) return
  }, [data])

  if (isLoading) {
    return (
      <section className="py-12 px-4">
        <p>Loading...</p>
      </section>
    )
  }

  if (isError) {
    return (
      <section className="py-12 px-4">
        <p>Error loading data</p>
      </section>
    )
  }

  if (!data) {
    return (
      <section className="py-12 px-4">
        <p>No data found.</p>
      </section>
    )
  }
  return (
    <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
      <Navigator title="About KIED" slug="ABOUT_KIED" />
      <h1 className="text-3xl font-semibold text-gray-800 pb-2">KIED</h1>
      <hr className="border-t-2 border-primaryBlue mb-6" />
      <div
        className="bg-cover bg-center bg-no-repeat rounded-xl py-8 md:py-12 lg:py-16 "
        style={{
          backgroundImage: `url(${InternshipBg})`,
        }}
      >
        <div className="mx-auto w-full px-4 md:px-14 ">
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-8 lg:gap-16 items-center">
            <div className="bg-white/90 backdrop-blur-sm p-6 md:p-8 lg:p-8 rounded-lg min-h-[440px] shadow">
              <h2 className="text-2xl md:text-3xl italic font-semibold text-gray-800 mb-4">
                {data?.name}
              </h2>
              {/* <p className="text-gray-700 text-sm md:text-base tracking-wide leading-relaxed">
                {data?.designation}
              </p> */}
              <div
                className="text-gray-900 text-sm md:text-base tracking-wide leading-relaxed mt-4 text-justify"
                dangerouslySetInnerHTML={{ __html: data?.description }}
              ></div>
            </div>
            <div className="w-full flex justify-center items-center">
              <img
                src={WorkImage}
                alt="EDC Work"
                className="w-full max-w-full object-cover rounded-lg shadow-md min-h-[290px] h-full"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full text-justify">
        <InfoCard
          iconSrc={AimIcon}
          title="Our Value"
          content="EDC values inclusivity, excellence, and adaptability with empowering entrepreneurs to build smart, responsible, and resilient businesses for Kerala’s future."
          textColor="text-orange-500"
        />
        <InfoCard
          iconSrc={MissionIcon}
          title="Our Mission"
          content="To develop and apply insights for providing inspiration forentrepreneur development, information for enterprise development and influence policy for industrial development."
          textColor="text-red-500"
        />
        <InfoCard
          iconSrc={VisionIcon}
          title="Our Vision"
          content="To be a global centre of knowledge for the smart and sustainable entrepreneurship development of the state."
          textColor="text-gray-700"
        />
      </div>
      <div className="mt-20 w-full">
        <div className="">
          <div className="w-full">
            <h4 className="text-2xl font-semibold text-gray-900 border-b border-primaryBlue pb-2 mb-6">
              HISTORY
            </h4>
            <ul className="space-y-4 text-gray-900 mb-4">
              <li className="flex items-start gap-2">
                <span className="text-md text-justify">
                  KIED was established as an autonomous body of the Government
                  of Kerala on 9th November 1994 and established in Kochi in
                  2005. It aimed to promote the spirit and culture of
                  entrepreneurship among the youth of Kerala by giving them
                  orientation in Human Resources Development and training in
                  skill development and leadership. Initially, the institute was
                  centred in Thiruvananthapuram and was later shifted to Seaport
                  Airport Road in Kalamassery, a rapidly flourishing industrial
                  hub in the state, which sandwiches both the ports and is
                  located nearby Gail India Limited, Hindustan Machine Tools,
                  Infopark, and Nest Special Economic Zone for IT. The location
                  is ideal for the institute, on account of a large number of
                  migrant labourers in the region.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutKied
